import React from 'react';

import DeviceEndOfSupportContainer from '@totem/components/deviceEndOfSupport/deviceEndOfSupportContainer';
import DeviceEndOfSupportLayout, {
  DeviceEndOfSupportExtra,
} from '@totem/components/deviceEndOfSupport/deviceEndOfSupportLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const DeviceEndOfSupportPage = () => (
  <ContentLayout>
    <DeviceEndOfSupportContainer>
      <IBCard
        isCovered
        title="Device End-of-Support"
        extra={<DeviceEndOfSupportExtra />}
      >
        <DeviceEndOfSupportLayout />
      </IBCard>
    </DeviceEndOfSupportContainer>
  </ContentLayout>
);

export default DeviceEndOfSupportPage;
